import React, { useState } from 'react'
import styled from 'styled-components'
import Colors from '../../../assets/styles/Colors'
import Responsive from '../../../assets/config/Responsive'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
//
//
const Accordion: React.FC<{
  children?: React.ReactNode
  title?: string
  editBtnText?: string
  editBtnOnchange?: () => void
  disableEditBtn?: boolean
  hideEditBtn?: boolean
  isOpen?: boolean
}> = ({
  children,
  title = 'Title',
  editBtnText = 'Edit',
  editBtnOnchange,
  disableEditBtn = false,
  hideEditBtn = false,
  isOpen = false,
}) => {
  //
  const [openAccordion, setOpenAccordion] = useState<boolean>(isOpen)
  //
  return (
    <Wrapper>
      <Head>
        <ArrowBtn onClick={() => setOpenAccordion(!openAccordion)}>
          <ArrowStyle $open={openAccordion} />
        </ArrowBtn>
        <HeadContent>
          <Title onClick={() => setOpenAccordion(!openAccordion)}>{title}</Title>
          {hideEditBtn ? null : (
            <EditBtn disabled={disableEditBtn} onClick={editBtnOnchange}>
              {editBtnText}
            </EditBtn>
          )}
        </HeadContent>
      </Head>
      {/*  */}
      <Content style={openAccordion ? {} : { display: 'none' }}>{children}</Content>
    </Wrapper>
  )
}
//
const Content = styled.div`
  padding-top: 26px;

  ${Responsive.mobile} {
    padding-top: 22px;
  }
`
const ArrowBtn = styled.button`
  display: flex;
  position: absolute;
  top: 3px;
  left: -30px;
  background-color: transparent;
  outline: none;
  border: unset;
  padding: 5px;

  ${Responsive.mobile} {
    top: 5px;
    left: -24px;
  }
`
const ArrowStyle = styled(RightArrow)<{ $open: boolean }>`
  transform: ${({ $open }) => ($open === true ? 'rotate(-90deg)' : 'rotate(90deg)')};
  margin-top: ${({ $open }) => ($open === true ? '-2px' : '0px')};
  color: ${Colors.primaryBlack};
  width: 16px;
  height: 16px;
  /*  */
  ${Responsive.tablet} {
    width: 13px;
  }
  ${Responsive.mobile} {
    width: 12px;
    height: 12px;
  }
`
const HeadContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
const EditBtn = styled.button`
  background-color: transparent;
  outline: none;
  padding: 3px;
  border: unset;
  text-decoration: underline;
  font-size: 14px;
  color: ${Colors.primaryBlack};

  &:disabled {
    opacity: 0.8;
  }
`
const Title = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  user-select: none;
  cursor: pointer;
`
const Head = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`
const Wrapper = styled.div`
  width: 100%;
  padding: 33px 48px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  border-radius: 8px;

  ${Responsive.mobile} {
    padding: 25px 20px 35px 27px;
  }
`
//
export default Accordion
